var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPrint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60156 1.625L2.625 4.25H1.5V3.57031V1.625C1.5 1.01562 1.99219 0.5 2.60156 0.5H8.57812C8.85938 0.5 9.16406 0.640625 9.375 0.851562L10.1484 1.625C10.3594 1.83594 10.5 2.14062 10.5 2.42188V4.25H9.375V2.42188L8.55469 1.625H2.60156ZM10.3125 5C11.2266 5 12 5.77344 12 6.6875V9.3125C12 9.64062 11.7422 9.875 11.4375 9.875H10.125V11.75C10.125 12.1719 9.77344 12.5 9.375 12.5H2.625C2.20312 12.5 1.875 12.1719 1.875 11.75V9.875H0.5625C0.234375 9.875 0 9.64062 0 9.3125V6.6875C0 5.77344 0.75 5 1.6875 5H10.3125ZM9 11.375V9.125H3V11.375H9ZM10.875 8.75V6.6875C10.875 6.38281 10.6172 6.125 10.3125 6.125H1.6875C1.35938 6.125 1.125 6.38281 1.125 6.6875V8.75H1.875C1.875 8.35156 2.20312 8 2.625 8H9.375C9.77344 8 10.125 8.35156 10.125 8.75H10.875Z",
    fill: "#15161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrint);
export default __webpack_public_path__ + "static/media/icon-print.b6189ed26b697ca4974761a52a97f4c9.svg";
export { ForwardRef as ReactComponent };